import { Document, Block } from "@contentful/rich-text-types"
import { BLOCKS } from "@contentful/rich-text-types"

export interface TableOfContentsItem {
  id: string
  text: string
  level: number
  children: TableOfContentsItem[]
}

export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim()
}

export function extractTextFromNode(node: any): string {
  if (typeof node === "string") {
    return node
  }

  if (node.nodeType === "text") {
    return node.value
  }

  if (node.content && Array.isArray(node.content)) {
    return node.content.map(extractTextFromNode).join("")
  }

  return ""
}

export function extractHeadingsFromRichText(richText: Document): TableOfContentsItem[] {
  const headings: Array<{ text: string; level: number; id: string }> = []

  function processNode(node: Block | any) {
    if (node.nodeType === BLOCKS.HEADING_2) {
      const text = extractTextFromNode(node)
      const id = generateSlug(text)
      headings.push({ text, level: 2, id })
    } else if (node.nodeType === BLOCKS.HEADING_3) {
      const text = extractTextFromNode(node)
      const id = generateSlug(text)
      headings.push({ text, level: 3, id })
    } else if (node.nodeType === BLOCKS.HEADING_4) {
      const text = extractTextFromNode(node)
      const id = generateSlug(text)
      headings.push({ text, level: 4, id })
    }

    if (node.content && Array.isArray(node.content)) {
      node.content.forEach(processNode)
    }
  }

  if (richText.content) {
    richText.content.forEach(processNode)
  }

  const result: TableOfContentsItem[] = []
  const stack: TableOfContentsItem[] = []

  headings.forEach((heading) => {
    const item: TableOfContentsItem = {
      id: heading.id,
      text: heading.text,
      level: heading.level,
      children: [],
    }

    while (stack.length > 0 && stack[stack.length - 1].level >= heading.level) {
      stack.pop()
    }

    if (stack.length === 0) {
      result.push(item)
    } else {
      stack[stack.length - 1].children.push(item)
    }

    stack.push(item)
  })

  return result
}
